import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { PagesProvider } from '../../../providers/pages-provider';



@Component({
  selector: 'page-cek-senet-ana-sayfa',
  templateUrl: 'cek-senet-ana-sayfa.html',
})
export class CekSenetAnaSayfaPage {
  menuler = [];
  gunSonu = false;
  constructor(public navCtrl: NavController,
    public navParams: NavParams) {
  }

  ionViewDidLoad() {
    this.MenuleriGoruntule();
  }
  menuItemClick(item) {
    var pagesProvider = new PagesProvider();
    var componentType = typeof item.PAGE_COMPONENT;
    var component;
    if (componentType === "string")
      component = pagesProvider.components[item.PAGE_COMPONENT];
    else
      component = item.PAGE_COMPONENT;

    this.navCtrl.push(component, { page: item.PARAM });
  }
  MenuleriGoruntule() {
    var pagesProvider = new PagesProvider();
    pagesProvider.menuler().then(a => {
      var sonuc = <any>a;

      this.menuler = sonuc.CEKSENET_MENU;
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/CekSenetIslemleri/cek-senet-ana-sayfa/cek-senet-ana-sayfa.ts